<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="ctfm"><span epub:type="pagebreak" id="pg_XI" title="XI"><span class="ePub-SC">ACRONYMS</span></span></p>
<p class="glo"><span class="ePub-SC">AOF</span>: Alliance of Families (Alianța Familiilor)</p>
<p class="glo"><span class="ePub-SC">CNCD</span>: National Council for Combatting Discrimination (Consiliul Național pentru Combaterea Discriminării)</p>
<p class="glo"><span class="ePub-SC">COC:</span> Cultuur-en Ontspanningscentrum</p>
<p class="glo"><span class="ePub-SC">COE</span>: Council of Europe</p>
<p class="glo"><span class="ePub-SC">ČSL</span>: Czechoslovak People’s Party (Československá strana lidová)</p>
<p class="glo"><span class="ePub-SC">ČSSD</span>: Czech Social Democratic Party (Česká strana sociálně demokratická)</p>
<p class="glo"><span class="ePub-SC">ENP</span>: European Neighborhood Policy</p>
<p class="glo"><span class="ePub-SC">EP</span>: European Parliament</p>
<p class="glo"><span class="ePub-SC">GI</span>: Gay Initiative (Gay iniciativa)</p>
<p class="glo"><span class="ePub-SC">G-LIGA</span>: G-League</p>
<p class="glo"><span class="ePub-SC">GLL</span>: Gay and Lesbian League (Gay a lesbická liga)</p>
<p class="glo"><span class="ePub-SC">HOS</span>: Movement for Civic Freedom (Hnutí za občanskou svobodu)</p>
<p class="glo"><span class="ePub-SC">HRHO</span>: Movement for Equality of Homosexual Citizens (Hnutí za rovnoprávnost homosexuálních občanů)</p>
<p class="glo"><span class="ePub-SC">HZDS</span>: Movement for a Democratic Slovakia (Hnutie za demokratické Slovensko)</p>
<p class="glo"><span class="ePub-SC">ICSE</span>: International Committee for Sexual Equality</p>
<p class="glo"><span class="ePub-SC">IGCLN-POLAND</span>: International Lesbian and Gay Culture Network in Poland</p>
<p class="glo"><span class="ePub-SC">ILGA</span>: International Lesbian, Gay, Bisexual, Trans and Intersex Association</p>
<p class="glo"><span class="ePub-SC">JOBBIK</span>: Movement for a Better Hungary (Jobbik Magyarországért Mozgalom)</p>
<p class="glo"><span class="ePub-SC">KDH</span>: Christian Democratic Movement (Kresťanskodemokratické hnutie)</p>
<p class="glo"><span class="ePub-SC">KDNP</span>: Christian Democrats (Kereszténydemokrata Néppárt)</p>
<p class="glo"><span class="ePub-SC">KDU-ČSL</span>: Christian Democratic Union–Czechoslovak People’s Party (Křesťanská a demokratická unie–Československá strana lidová)</p>
<p class="glo"><span epub:type="pagebreak" id="pg_XII" title="XII"><span class="ePub-SC">KPH</span>: Campaign Against Homophobia (Kampania Przeciw Homofobii)</span></p>
<p class="glo"><span class="ePub-SC">LGBT</span>: lesbian, gay, bisexual, and transsexual</p>
<p class="glo"><span class="ePub-SC">LPR</span>: League of Polish Families (Liga Polskich Rodzin)</p>
<p class="glo"><span class="ePub-SC">MDF</span>: Hungarian Democratic Forum (Magyar Demokrata Fórum)</p>
<p class="glo"><span class="ePub-SC">MCF</span>: MCF Roma Alliance Party (MCF Roma összefogás)</p>
<p class="glo"><span class="ePub-SC">MIÉP</span>: Hungarian Justice and Life Party (Magyar Igazság és Élet Pártja)</p>
<p class="glo"><span class="ePub-SC">MONAR</span>: Youth Movement against Drug Addiction (Młodzieżowy Ruch na Rzecz Przeciwdziałania Narkomanii)</p>
<p class="glo"><span class="ePub-SC">MP</span>: Member of Parliament</p>
<p class="glo"><span class="ePub-SC">MSZP</span>: Hungarian Socialist Party (Magyar Szocialista Párt)</p>
<p class="glo"><span class="ePub-SC">MW</span>: All-Poland Youth (Młodzież Wszechpolska)</p>
<p class="glo"><span class="ePub-SC">NGO</span>: nongovernmental organization</p>
<p class="glo"><span class="ePub-SC">ODS</span>: Civic Democratic Party (Občanská demokratická strana)</p>
<p class="glo"><span class="ePub-SC">OI</span>: Otherness Initiative (Iniciatíva Inakosť)</p>
<p class="glo"><span class="ePub-SC">PDSR</span>: Party of Social Democracy of Romania (Partidul Democraţiei Sociale din România)</p>
<p class="glo"><span class="ePub-SC">PIS</span>: Law and Justice (Prawo i Sprawiedliwość)</p>
<p class="glo"><span class="ePub-SC">PO</span>: Civic Platform (Platforma Obywatelska)</p>
<p class="glo"><span class="ePub-SC">POS</span>: political opportunity structure</p>
<p class="glo"><span class="ePub-SC">PM</span>: prime minister</p>
<p class="glo"><span class="ePub-SC">PRM</span>: Greater Romania Party (Partidul România Mare)</p>
<p class="glo"><span class="ePub-SC">PROUD</span>: Platform for Equality, Recognition, and Diversity (Platforma pro rovnoprávnost, uznání a diverzitu)</p>
<p class="glo"><span class="ePub-SC">PSNS</span>: Real Slovak National Party (Pravá slovenská národná strana)</p>
<p class="glo"><span class="ePub-SC">PUNR</span>: Romanian National Unity Party (Partidul Unităţii Naţionale a Românilor)</p>
<p class="glo"><span class="ePub-SC">QLF</span>: Queer Leaders Forum</p>
<p class="glo"><span class="ePub-SC">ROP</span>: Movement to Rebuild Poland (Ruch Odbudowy Polski)</p>
<p class="glo"><span class="ePub-SC">SDK</span>: Slovak Democratic Coalition (Slovenská demokratická koalícia)</p>
<p class="glo"><span class="ePub-SC">SDĽ</span>: Party of the Democratic Left (Strana demokratickej ľavice)</p>
<p class="glo"><span class="ePub-SC">SLD</span>: Democratic Left Alliance (Sojusz Lewicy Demokratycznej)</p>
<p class="glo"><span class="ePub-SC">SMO</span>: social movement organization</p>
<p class="glo"><span class="ePub-SC">SNS</span>: Slovak National Party (Slovenská národná strana)</p>
<p class="glo"><span class="ePub-SC">SO</span>: Self-Defense (Samoobrona)</p>
<p class="glo"><span class="ePub-SC">SOHO</span>: Organization of Associations of Homosexual Citizens (Sdružení organizací homosexuálních občanů)</p>
<p class="glo"><span epub:type="pagebreak" id="pg_XIII" title="XIII"><span class="ePub-SC">SPR-RSČ</span>: Association for the Republic–Republican Party of Czechoslovakia (Sdružení pro Republiku–Republikánská strana Československa)</span></p>
<p class="glo"><span class="ePub-SC">SZDSZ</span>: Alliance of Free Democrats–Hungarian Liberal Party (Szabad Demokraták Szövetsége–a Magyar Liberális Párt)</p>
<p class="glo"><span class="ePub-SC">TR</span>: Your Movement (Twój Ruch)</p>
<p class="glo"><span class="ePub-SC">WVS</span>: World Values Survey</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acronyms.vue?9983a9d0